import { connect, MapStateToProps } from "react-redux";

import { getInitialRawValue } from "@multiweb/reactControls";
import { isDarkTheme } from "@multiweb/reactCore/theme";
import { IAppState } from "../../setup/types";
import { RichTextEditorWrapperComponent } from "./RichTextEditorWrapperComponent";
import { IRichTextEditorWrapperProps } from "./types";

const mapStateToProps: MapStateToProps<Pick<IRichTextEditorWrapperProps, "darkTheme" | "initialValue">, IRichTextEditorWrapperProps, IAppState> = (state, { dataKey }) => ({
    darkTheme: isDarkTheme(state),
    initialValue: getInitialRawValue(state, dataKey ?? ""),
});

export const RichTextEditorWrapper = connect(mapStateToProps)(RichTextEditorWrapperComponent);
